module.exports = __webpack_public_path__ + "07ebe96f8fd53717e959ca356e69234c.woff2";